import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

/**
 * Blocks role 6 (Patient) from staff practice management URLs.
 */
const NonPatientRoute = ({ children }) => {
  const { user } = useSelector((state) => state.auth);
  if (Number(user?.role_id) === 6) {
    return <Navigate to="/patient-dashboard" replace />;
  }
  return children;
};

export default NonPatientRoute;
